'use client';

import { Tracking, VideoPayload, VideoPlayEvent } from '@analytics/shared';
import { useTracking } from 'react-tracking';

export type TrackVideoPlay = ReturnType<typeof useTrackVideoPlay>;

export const useTrackVideoPlay = () => {
  const { trackEvent } = useTracking<VideoPlayEvent>({
    eventType: Tracking.videoPlay,
  });

  return (eventInfo: VideoPayload['eventInfo']): void => {
    trackEvent({
      eventInfo,
    });
  };
};
